"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var DoubleLeftOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M528.17 115.904a42.667 42.667 0 0157.515 4.139l2.411 2.773a42.667 42.667 0 01-4.139 57.536L232.811 511.851l351.146 331.797 2.582 2.645a42.667 42.667 0 01-61.184 59.392L157.78 558.38l-2.581-2.603a64 64 0 012.603-90.453l367.573-347.008zm277.334 0a42.667 42.667 0 0157.515 4.139l2.41 2.773a42.667 42.667 0 01-4.138 57.536L510.144 511.851l351.147 331.797 2.581 2.645a42.667 42.667 0 01-61.184 59.392L435.115 558.38l-2.582-2.603a64 64 0 012.603-90.453l367.573-347.008z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
DoubleLeftOutlined.displayName = "DoubleLeftOutlined";
var _default = exports["default"] = DoubleLeftOutlined;